import { DirectDebitFormField } from '../../models/direct-debit/direct-debit-form-field.enum';
import { DirectDebitFormValue } from '../../models/direct-debit/direct-debit-form-value.type';

export const mockDirectDebitFormValue: DirectDebitFormValue = {
  [DirectDebitFormField.AccountName]: 'accountName',
  [DirectDebitFormField.AccountNumber]: '88888888',
  [DirectDebitFormField.IBAN]: null,
  [DirectDebitFormField.SortCode]: '205958',
  [DirectDebitFormField.PaymentDate]: 1,
  [DirectDebitFormField.AccountHolderConfirmation]: true,
  [DirectDebitFormField.TermsAndConditions]: true,
  [DirectDebitFormField.PaperlessPreference]: false,
  [DirectDebitFormField.PaymentToken]: null,
};
